import { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { UserDietOverview } from '@/components/diet-plans-v2/user-diet-overview';

function UserDietContent() {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('id');

  if (!userId) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Diet Management</h1>
          <p className="text-muted-foreground">No user selected</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Diet Management</h1>
        <p className="text-muted-foreground">
          View and manage user's diet profile and plans
        </p>
      </div>

      <UserDietOverview userId={userId} />
    </div>
  );
}

export default function UserDietPage() {
  return (
    <Suspense fallback={<div className="text-center py-8">Loading...</div>}>
      <UserDietContent />
    </Suspense>
  );
}
